import { austria, germany, switzerland } from "../styles/flags"

import { AddressPattern } from "../sdk/types"
import { ReactNode } from "react"

type CountryName =
    | "configuration_countries_germany"
    | "configuration_countries_austria"
    | "configuration_countries_belgium"
    | "configuration_countries_cyprus"
    | "configuration_countries_denmark"
    | "configuration_countries_estonia"
    | "configuration_countries_spain"
    | "configuration_countries_france"
    | "configuration_countries_great_britain"
    | "configuration_countries_croatia"
    | "configuration_countries_ireland"
    | "configuration_countries_iceland"
    | "configuration_countries_italy"
    | "configuration_countries_latvia"
    | "configuration_countries_lichtenstein"
    | "configuration_countries_lithuania"
    | "configuration_countries_luxembourg"
    | "configuration_countries_hungary"
    | "configuration_countries_malta"
    | "configuration_countries_netherlands"
    | "configuration_countries_norway"
    | "configuration_countries_poland"
    | "configuration_countries_portugal"
    | "configuration_countries_romania"
    | "configuration_countries_slovenia"
    | "configuration_countries_slovakia"
    | "configuration_countries_finland"
    | "configuration_countries_sweden"
    | "configuration_countries_greece"
    | "configuration_countries_bulgaria"
    | "configuration_countries_switzerland"

export type Country = {
    name: CountryName
    id: number
    countryCode: string
    regex: RegExp
    length: number
    type: string
    addressTypes: AddressPattern[]
    callingCode: string
    ibanAvailable?: boolean
    flag?: ReactNode
}

const countries: Country[] = [
    {
        name: "configuration_countries_germany",
        id: 0,
        countryCode: "DE",
        regex: /\b[0-9]{5}\b/,
        length: 5,
        type: "tel",
        addressTypes: ["Default", "Packstation", "Postfiliale"],
        callingCode: "+49",
        ibanAvailable: true,
        flag: germany,
    },
    {
        name: "configuration_countries_austria",
        id: 1,
        countryCode: "AT",
        regex: /\b[0-9]{4}\b/,
        length: 4,
        type: "tel",
        addressTypes: ["Default"],
        callingCode: "+43",
        ibanAvailable: true,
        flag: austria,
    },
    {
        name: "configuration_countries_belgium",
        id: 2,
        countryCode: "BE",
        regex: /\b[0-9]{4}\b/,
        length: 4,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+32",
    },
    {
        name: "configuration_countries_cyprus",
        id: 3,
        countryCode: "CY",
        regex: /\b[0-9]{4}\b/,
        length: 4,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+357",
    },
    {
        name: "configuration_countries_denmark",
        id: 4,
        countryCode: "DK",
        regex: /\b[0-9]{4}\b/,
        length: 4,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+45",
    },
    {
        name: "configuration_countries_estonia",
        id: 5,
        countryCode: "EE",
        regex: /\b[0-9]{5}\b/,
        length: 5,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+372",
    },
    {
        name: "configuration_countries_spain",
        id: 6,
        countryCode: "ES",
        regex: /\b[0-9]{5}\b/,
        length: 5,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+34",
    },
    {
        name: "configuration_countries_france",
        id: 7,
        countryCode: "FR",
        regex: /\b[0-9]{5}\b/,
        length: 5,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+33",
    },
    {
        name: "configuration_countries_great_britain",
        id: 8,
        countryCode: "GB",
        regex: /\b[A-Z]{1,2}[0-9R][0-9A-Z]?\s*[0-9][ABD-HJLNP-UW-Z]{2}\b/,
        length: 8,
        type: "text",
        addressTypes: ["freieEingabe"],
        callingCode: "+44",
    },
    {
        name: "configuration_countries_croatia",
        id: 9,
        countryCode: "HR",
        regex: /\b[0-9]{5}\b/,
        length: 5,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+385",
    },
    {
        name: "configuration_countries_ireland",
        id: 10,
        countryCode: "IE",
        regex: /\b(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}\b/,
        length: 8,
        type: "text",
        addressTypes: ["freieEingabe"],
        callingCode: "+353",
    },
    {
        name: "configuration_countries_iceland",
        id: 11,
        countryCode: "IS",
        regex: /\b[0-9]{3}\b/,
        length: 3,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+354",
    },
    {
        name: "configuration_countries_italy",
        id: 12,
        countryCode: "IT",
        regex: /\b[0-9]{5}\b/,
        length: 5,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+39",
    },
    {
        name: "configuration_countries_latvia",
        id: 13,
        countryCode: "LV",
        regex: /\b[Ll][Vv][- ]{0,1}\d{4}\b/,
        length: 7,
        type: "text",
        addressTypes: ["freieEingabe"],
        callingCode: "+371",
    },
    {
        name: "configuration_countries_lichtenstein",
        id: 14,
        countryCode: "LI",
        regex: /\b[0-9]{4}\b/,
        length: 4,
        type: "tel",
        addressTypes: ["Default"],
        callingCode: "+423",
    },
    {
        name: "configuration_countries_lithuania",
        id: 15,
        countryCode: "LT",
        regex: /\b[0-9]{5}\b/,
        length: 5,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+370",
    },
    {
        name: "configuration_countries_luxembourg",
        id: 16,
        countryCode: "LU",
        regex: /\b[0-9]{4}\b/,
        length: 4,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+352",
    },
    {
        name: "configuration_countries_hungary",
        id: 17,
        countryCode: "HU",
        regex: /\b[0-9]{4}\b/,
        length: 4,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+36",
    },
    {
        name: "configuration_countries_malta",
        id: 18,
        countryCode: "MT",
        regex: /\b[A-Za-z]{3}\s{0,1}\d{4}\b/,
        length: 8,
        type: "text",
        addressTypes: ["freieEingabe"],
        callingCode: "+356",
    },
    {
        name: "configuration_countries_netherlands",
        id: 19,
        countryCode: "NL",
        regex: /\b\d{4}\s{0,1}[A-Za-z]{2}\b/,
        length: 7,
        type: "text",
        addressTypes: ["freieEingabe"],
        callingCode: "+31",
    },
    {
        name: "configuration_countries_norway",
        id: 20,
        countryCode: "NO",
        regex: /\b[0-9]{4}\b/,
        length: 4,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+47",
    },
    {
        name: "configuration_countries_poland",
        id: 21,
        countryCode: "PL",
        regex: /\b\d{2}[- ]?\d{3}\b/,
        length: 6,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+48",
    },
    {
        name: "configuration_countries_portugal",
        id: 22,
        countryCode: "PT",
        regex: /\b\d{4}([- ]{0,1}\d{3}){0,1}\b/,
        length: 8,
        type: "text",
        addressTypes: ["freieEingabe"],
        callingCode: "+351",
    },
    {
        name: "configuration_countries_romania",
        id: 23,
        countryCode: "RO",
        regex: /\b\d{6}\b/,
        length: 6,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+40",
    },
    {
        name: "configuration_countries_slovenia",
        id: 24,
        countryCode: "SI",
        regex: /\b[0-9]{4}\b/,
        length: 4,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+386",
    },
    {
        name: "configuration_countries_slovakia",
        id: 25,
        countryCode: "SK",
        regex: /\b\d{3}\s{0,1}\d{2}\b/,
        length: 6,
        type: "text",
        addressTypes: ["freieEingabe"],
        callingCode: "+421",
    },
    {
        name: "configuration_countries_finland",
        id: 26,
        countryCode: "FI",
        regex: /\b[0-9]{5}\b/,
        length: 5,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+358",
    },
    {
        name: "configuration_countries_sweden",
        id: 27,
        countryCode: "SE",
        regex: /\b\d{3}\s?\d{2}\b/,
        length: 6,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+46",
    },
    {
        name: "configuration_countries_greece",
        id: 28,
        countryCode: "GR",
        regex: /\b[0-9]{3}[ ]?[0-9]{2}\b/,
        length: 6,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+30",
    },
    {
        name: "configuration_countries_bulgaria",
        id: 29,
        countryCode: "BG",
        regex: /\b[0-9]{4}\b/,
        length: 4,
        type: "tel",
        addressTypes: ["freieEingabe"],
        callingCode: "+359",
    },
    {
        name: "configuration_countries_switzerland",
        id: 30,
        countryCode: "CH",
        regex: /\b[0-9]{4}\b/,
        length: 4,
        type: "tel",
        addressTypes: ["Default"],
        callingCode: "+41",
        flag: switzerland,
    },
]

export { countries }
